import http from '@gp/utils/httpTS';
import { LiveTitleDataType } from '../types/services';

export const fetchLiveTitleData = (params: {
  'select_id': string[],
  'start_date': string,
  'end_date': string,
  'yoy': boolean,
  'mom': boolean,
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}): Promise<LiveTitleDataType> => {
  return http.post('/api/v1/globalpedia_pc/studio_monthly_report/live_title', params);
};

export const liveTitleDownLoad = (params: {
  'file_type': 1 | 2, // 1: csv 2: excal
  'select_id': string[],
  'start_date': string,
  'end_date': string,
  'yoy': boolean,
  'mom': boolean,
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_monthly_report/live_title/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
